import { ref, computed, reactive, UnwrapRef, toRef, Ref, onMounted, onUnmounted } from '@vue/composition-api';
import smh, { SMH } from '@/renderer/scripts/smh';
import tips, { MsgError } from '@/renderer/scripts/utils/tips';
import router from '@/renderer/router/index';
import ipc from '@/renderer/scripts/utils/ipc';
import store from '@/renderer/store';
type DirData = {
  list: any[];
  subDirCount: number;
  crumbs: string[];
  dirAuth: SMH.AuthorityList;
};
type PageParams = {
  pageNum: number;
  pageSize: number;
};
type Handler = {
  dirData: UnwrapRef<DirData>;
  dirList: Ref<object>;
  loadMoreShow: Ref<boolean>;
  loading: Ref<boolean>;
  curPath: Ref<string>;
  pageParams: UnwrapRef<PageParams>;
  methods: {
    changeCrumbs: (path: string, action: 'add' | 'remove', index?: number) => void;
    loadMore: () => void;
  };
};
export default function handler(spaceId: Ref<SpaceId>, changeCrumbsWhenRefresh = false): Handler {
  const dirData = reactive<DirData>({
    list: [],
    subDirCount: 0,
    crumbs: [],
    dirAuth: {
      canAuthorize: true,
      canDelete: true,
      canDownload: true,
      canModify: true,
      canPreview: true,
      canShare: true,
      canUpload: true,
      canView: true,
    },
  });
  if (router.currentRoute.query?.path) {
    const { path } = router.currentRoute.query;
    dirData.crumbs = (path as string).split('/');
  }
  const pageParams = {
    pageNum: 1,
    pageSize: 100, // 目前单页最大数
  };

  const crumbs = toRef(dirData, 'crumbs');
  const dirPath = computed(() => crumbs.value.join('/'));
  const nextMarker = 0;
  const loading = ref(false);
  const dirList = computed(() => dirData.list);
  const loadMoreShow = computed(() => dirData.list.length < dirData.subDirCount);
  const methods = {
    async pullDirList() {
      const params = {
        page: pageParams.pageNum,
        pageSize: pageParams.pageSize,
        dirPath: dirPath.value,
        nextMarker,
        prderBy: undefined,
        orderByType: 'desc',
        spaceId: spaceId.value,
        filter: 'onlyDir',
        spaceOrgId: +(router.currentRoute.query?.spaceOrgId || store.getters.orgId),
      };
      try {
        loading.value = true;
        const { data: resData } = await smh.commonAPI.listDirectory(params);
        loading.value = false;
        const temp = resData.contents;
        dirData.subDirCount = resData.subDirCount;
        dirData.dirAuth = resData.authorityList;
        dirData.list = [...new Set([...dirData.list, ...temp])];
      } catch (e) {
        loading.value = false;
        tips.error(e as MsgError);
      }
    },
    changeCrumbs(path: string, action: 'add' | 'remove', index?: number) {
      if (path === '') {
        crumbs.value = [];
      } else if (action === 'add') {
        crumbs.value.push(path);
      } else if (action === 'remove') {
        crumbs.value.splice(index as number);
      }
      pageParams.pageNum = 1;
      dirData.list = [];
      methods.pullDirList();
    },
    loadMore() {
      pageParams.pageNum += 1;
      methods.pullDirList();
    },
  };
  const selectFresh = (data: Array<any>) => {
    if (!data) return;
    dirData.list.unshift(...data);
    if (changeCrumbsWhenRefresh && data.length === 1 && data[0].name) {
      methods.changeCrumbs(data[0].name, 'add', undefined);
    }
  };
  onMounted(() => {
    ipc.on(ipc.RENDERER_EVENTS_MAP.COMMAND_REFRESH, selectFresh);
    methods.pullDirList();
  });
  onUnmounted(() => {
    ipc.off(ipc.RENDERER_EVENTS_MAP.COMMAND_REFRESH, selectFresh);
  });
  return {
    dirData,
    dirList,
    loadMoreShow,
    loading,
    curPath: dirPath,
    pageParams,
    methods,
  };
}
